import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FlightOmnisEditModal from './Elements/FlightOmnisEditModal';
import Overlay from '../Miscelania/Overlay';
import Topo from '../Layout/Topo';
import getLocale from '../../i18n/getLocale';

class FlightOmnisIndex extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      modal_props: false,
      flight_omnis: [],
      data_flight_omnis: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.loadData = this.loadData.bind(this);
    this.refreshFlightOmnis = this.refreshFlightOmnis.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/omni/justificativas/atraso';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_omnis: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    }); /* Lista de justificativas omni */
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
      reason: this.state.reason,
      session: this.state.session,
      type: this.state.type,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/omni/justificativa/atraso', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.refreshFlightOmnis(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshFlightOmnis (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/omni/justificativas/atraso';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_omnis: responseJson.data,  modal: false});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }


  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/referencias/omni/justificativa/atraso/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(id) {
    var data = this.state.flight_omnis;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  showModal(event) {
    var self = this;
    var id = event.currentTarget.value;

    var data = self.state.flight_omnis;
    data.map(function(dado, index){
      if (dado.id == id) {
        self.setState({
          data_flight_omnis: dado,
          modal_props: true,
        });
      }
    });
  }

  closeModal(responseJson) {
    this.setState({
      modal_props: false,
      data_flight_omnis: {},
    });
  }



  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.Nome}</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.placeholder.Nome} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.Motivo}:</label>
              <input type="text" name="reason" className="form-control" placeholder={this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.placeholder.Motivo} value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.Setor}</label>
              <input type="text" name="session" className="form-control" placeholder={this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.placeholder.Setor} value={this.state.session} onChange={this.handleChange.bind(this, 'session')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.placeholder.SelecioneTipo}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={[
                  {value: "departure", label: this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.opcoesTipo.Decolagem},
                  {value: "flight", label: this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.opcoesTipo.TempoDeVoo},
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.formulario.botaoAdicionarJustificativaDeAtrasoOmni}</button>
          </div>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.flight_omnis} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.semJustificativasAtrasoOmni}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.Motivo}</TableHeaderColumn>
        <TableHeaderColumn dataField="session" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.Setor}</TableHeaderColumn>
        <TableHeaderColumn dataField="type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.Tipo}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.JustificativaDeAtrasoOmni.AdicionarJustificativaDeAtrasoOmni.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
      <FlightOmnisEditModal handleAlert={self.handleAlert} closeModal={self.closeModal} modal_props={self.state.modal_props} data_flight_omnis={self.state.data_flight_omnis} refreshTable={self.refreshFlightOmnis} />
    </div>
  </div>
</div>
    );
  }
}

export default FlightOmnisIndex;



// WEBPACK FOOTER //
// ./src/Components/FlightOmnis/FlightOmnisIndex.js